import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { LiveMealResponseEntity } from '../../domain/entities/LiveMealResponseEntity'
import type { GetMealStreamsAdminResponse } from '@/backend/market'
import { LiveMealEntity } from '../../domain/entities/LiveMealEntity'
import { LiveMealModel } from './LiveMealModel'

export class LiveMealResponseModel extends LiveMealResponseEntity {
  constructor(dataDto: GetMealStreamsAdminResponse) {
    super()
    const liveMealModels = dataDto.meals?.map((meal) => new LiveMealModel(meal as LiveMealEntity))
    mapEntityProperties<LiveMealResponseEntity>(this, dataDto, {
      map: {
        meals: liveMealModels
      }
    })
  }
}
